import {
  UniversalContext,
  useUniversalContext,
} from "@cxc/react-universal-components";
import { useEffect, useState } from "react";
import { getRankedPersonas } from "../../clients/AEMClient";

interface RankedPersonaResponse {
  personaRanking: string[];
  entitlements: string[];
  error?: string;
}
type RankedPersonaValue = Record<string, RankedPersonaResponse>;

interface RankedPersonaReturnProps {
  rankedPersonaValue: RankedPersonaValue;
}

interface UseRankedPersonaProps {
  locale: string;
  scope: string;
  authenticated: boolean;
  aemBaseUrl: string;
}

const useRankedPersonas = (
  props: UseRankedPersonaProps,
): RankedPersonaReturnProps => {
  const { scope, locale, authenticated, aemBaseUrl } = props;
  const { subscribeScopedValue, setScopedValue } =
    useUniversalContext() as UniversalContext;

  const rawCachedValue = subscribeScopedValue(
    scope,
    "RankedPersonas",
  ) as RankedPersonaValue;

  const [rankedPersonaValue, setRankedPersonaValue] = useState(rawCachedValue);

  useEffect(() => {
    if (rankedPersonaValue) {
      return;
    }

    if (!authenticated) {
      return;
    } else {
      getRankedPersonas(aemBaseUrl, locale)
        .then((value) => {
          setScopedValue(scope, "RankedPersonas", value);
          setRankedPersonaValue(value);
        })
        .catch(() => {
          setRankedPersonaValue({
            error: {
              personaRanking: [""],
              entitlements: [""],
            },
          });
          console.error("error fetching ranked persona");
        });
    }
  }, [
    locale,
    setScopedValue,
    rawCachedValue,
    scope,
    rankedPersonaValue,
    authenticated,
  ]);
  return {
    rankedPersonaValue,
  };
};

export { useRankedPersonas };
export type {
  RankedPersonaResponse,
  RankedPersonaReturnProps,
  RankedPersonaValue,
  UseRankedPersonaProps,
};
